import { createAction, props } from "@ngrx/store";
import { ClientSettings } from "src/model/class/client-settings";
import { BIGModeReading } from "src/components/shared-components/enum/enumDevice";
import { ApplicationTheme } from "src/components/shared-components/enum/enumMisc";
import { ClientSettingsStoreAction } from "src/components/shared-components/enum/enumStoreAction";
import { TypeBrightness } from "src/model/enum/enumTypeBrightness";

/**
 * Client settings create object action
 */
export const clientSettingCreateObjectAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_CREATE_OBJECT
);

/**
 * Client settings init complete action
 */
export const clientSettingInitCompleteAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_INIT_COMPLETE,
  props<{ clientSettings: ClientSettings }>()
);

/**
 * Client settings set device action language
 */
export const clientSettingSetLanguageDeviceAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_SET_LANGUAGE_BY_DEVICE,
  props<{ clientSettings: ClientSettings }>()
);

/**
 * Client settings update generic
 */
export const clientSettingsUpdateAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_GENERIC,
  props<{ clientSettings: ClientSettings }>()
);

/**
 * Client setting update specific setting value string
 */
export const clientSettingsUpdateSpecificSettingAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_SPECIFIC,
  props<{ settingsName: string; settingsValue: any }>()
);

/**
 * Client setting update device name
 */
export const clientSettingsUpdateDeviceNameSettingAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_DEVICE_NAME,
  props<{ deviceName: string }>()
);

/**
 * Client setting update default controllabe Relay
 */
export const clientSettingsUpdateDefaultRelaySettingAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_DEFAULT_RELAY,
  props<{ defaultRelay: number }>()
);

/**
 * Client setting update default extension of relays activation period
 */
export const clientSettingsUpdateDefaultRelayActivationTimeSettingAction =
  createAction(
    ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_DEFAULT_RELAY_ACTIVATION_TIME,
    props<{ defaultRelayActivationTime: number }>()
  );

/**
 * Client setting update card reading mode
 */
export const clientSettingsUpdateCardReadingModeAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_CARD_READING_MODE,
  props<{ cardReadingMode: BIGModeReading }>()
);

/**
 * Client setting update "Time limit enablers" list
 */
export const clientSettingsUpdateRelayTimeLimitEnablersListAction =
  createAction(
    ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_ENABLERS_LIST_RELAYS_TIMES_LIMIT,
    props<{ enablersTimeLimitList: Array<boolean> }>()
  );

/**
 * Client setting update "Time limit enablers" list
 */
export const clientSettingsUpdateMaximumRelayActivationTimeSettingListAction =
  createAction(
    ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_MAXIMUM_RELAY_ACTIVATION_TIME_LIST,
    props<{ maximumTimeLimitList: Array<number> }>()
  );

/**
 * Client setting update enable/disable maximum time-limit on peculiar device-integrated relay activation
 */
export const clientSettingsUpdateSingleRelayTimeLimitEnableAction =
  createAction(
    ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_ENABLE_TIME_LIMIT_RELAY_ACTIVATION,
    props<{ selctedRelay: number; enableHardTimeLImit: boolean }>()
  );

/**
 * Client setting update extension of maximum time-limit on peculiar device-integrated relays activation
 */
export const clientSettingsUpdateMaximumSingleRelayActivationTimeSettingAction =
  createAction(
    ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_MAXIMUM_RELAY_ACTIVATION_TIME,
    props<{ selctedRelay: number; maximumRelayActivationTime: number }>()
  );

export const clientSettingsUpdateParamBrightness = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_SET_BRIGTHNESS,
  props<{
    enableBrightnessSettings: boolean;
    typeBrightnessSettings: TypeBrightness;
    timeBrightness: number;
    percentageBrightness: number;
    defaultBrightness: number;
  }>()
);

export const clientSettingsUpdateTimeInactivitySupervision = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_SET_TIME_INACTIVITY_SUPERVISION,
  props<{
    timeInactivitySupervision: number;
  }>()
);

export const clientSettingsUpdateEventsBlackBox = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_NUMBER_EVENTS_BLACK_BOX,
  props<{
    numberEventsBlackBox: number;
  }>()
);

/**
 * Client setting update enable/disable maximum time-limit on device-integrated relays activation
 */
/*
export const clientSettingsUpdateRelayTimeLimitEnableAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_ENABLE_TIME_LIMIT_RELAY_ACTIVATION,
  props<{ enableHardTimeLImit: boolean }>()
);
*/

/**
 * Client setting update extension of maximum time-limit on device-integrated relays activation
 */
/*
export const clientSettingsUpdateMaximumRelayActivationTimeSettingAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_MAXIMUM_RELAY_ACTIVATION_TIME,
  props<{ maximumRelayActivationTime: number }>()
);
*/

/**
 * Client setting update helper map
 */
export const clientSettingsUpdateHelperAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_HELPER,
  props<{ helpers: Map<number, string> }>()
);

/**
 * Client setting update supervision font size
 */
export const clientSettingsUpdateSupervisionFontSizeAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_SET_SUPERVISION_FONT_SIZE,
  props<{ fontSize: number }>()
);

/**
 * Client setting update sibo device id
 */
export const clientSettingsUpdateSiboDeviceIDAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_SET_DEVICE_SIBO_ID,
  props<{ idDevice: number }>()
);

/**
 * Client setting update kiosk mode vieww
 */
export const clientSettingsUpdateKioskModeAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_KIOSK_MODE,
  props<{ kioskMode: boolean }>()
);

/**
 * Client settings update supervision viewe mode
 */
export const clientSettingsSetSupervisionModeViewAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_SET_SUPERVISION_VIEW_MODE,
  props<{ viewMode: boolean }>()
);

/**
 * Client settings update language
 */
export const clientSettingsUpdateLanguageAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_APP_LANGUAGE,
  props<{ lang: string }>()
);

/**
 * Client settings update show button connection exit
 */
export const clientSettingsUpdateShowButtonConnectionExitAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_SHOW_BUTTON_CONNECTION_EXIT,
  props<{ showButtonCommandExit: boolean }>()
);

/**
 * Client settings update kiosk mode password
 */
export const clientSettingsUpdateKioskModePasswordAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_KIOSK_MODE_PASSWORD,
  props<{ kioskModePassword: string }>()
);

/**
 * Client settings update Administrator feature password
 */
export const clientSettingsUpdateAdminFeaturesPasswordAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_ADMIN_FEATURES_PASSWORD,
  props<{ adminFeaturesPassword: string }>()
);

/**
 * Client settings update auto restart on boot
 */
export const clientSettingsUpdateAutoRestartOnBootAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_AUTO_RESTART_ON_BOOT,
  props<{ autoStartOnReboot: boolean }>()
);

export const clientSettingsUpdateCustomStartingAccessEnvironmentcartegoryAction =
  createAction(
    ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_CUSTOM_STARTING_ACCESS_ENVIRONMENT_CATEGORY,
    props<{ accessCategory: number }>()
  );

/**
 * Client settings update enable remote log
 */
export const clientSettingsUpdateEnableRemobteLogAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_ENABLE_REMOTE_LOG,
  props<{ enableRemoteLog: boolean }>()
);

/**
 * Client settings update remote log level
 */
export const clientSettingsUpdateRemoteLogLevelAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_UPDATE_REMOTE_LOG_LEVEL,
  props<{ remoteLogLevel: number }>()
);

/**
 * Client settings to handle application theme
 */
export const clientSettingsSetApplicationThemeAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_SET_APPLICATION_THEME,
  props<{ theme: ApplicationTheme }>()
);

/**
 * Client settings to handle digital place flag
 */
export const clientSettingsSetDigitalPlaceFlagAction = createAction(
  ClientSettingsStoreAction.CLIENT_SETTINGS_SET_DIGITAL_PLACE_FLAG,
  props<{ isDigitalPlace: boolean }>()
);
